<template>
  <v-dialog
    v-model="dialog"
    width="50%"
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <v-form ref="form" v-model="valid" @submit.prevent="submit()">
      <v-card :loading="loading">
        <v-card-title class="headline">Change Password</v-card-title>
        <v-card-text>

        <div>
        <v-alert type="error" v-show="accountStatus.error">
          Error: {{ accountStatus.message || "Password change failed, please try again." }}
        </v-alert>
        </div>

          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="form.currentPassword"
                label="Current Password"
                :error-messages="[].concat(fieldErrors('form.currentPassword'))"
                :blur="$v.form.currentPassword.$touch()"
                :append-icon="currentVisible ? 'visibility' : 'visibility_off'"
                :type="currentVisible ? 'text' : 'password'"
                @click:append="currentVisible = !currentVisible"
              />
            </v-col>

            <v-col cols="12">
              <v-text-field
                v-model="form.newPassword"
                label="New Password"
                :error-messages="[].concat(fieldErrors('form.newPassword'))"
                :blur="$v.form.newPassword.$touch()"
                :append-icon="newVisible ? 'visibility' : 'visibility_off'"
                :type="newVisible ? 'text' : 'password'"
                @click:append="newVisible = !newVisible"
              />
            </v-col>

            <v-col cols="12">
              <v-text-field
                v-model="form.confirmPassword"
                label="Confirm New Password"
                :error-messages="[].concat(fieldErrors('form.confirmPassword'))"
                :blur="$v.form.confirmPassword.$touch()"
                :append-icon="confirmVisible ? 'visibility' : 'visibility_off'"
                :type="confirmVisible ? 'text' : 'password'"
                @click:append="confirmVisible = !confirmVisible"
              />
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions class="mt-2">
          <v-btn @click="closeDelete">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="info"
            type="submit"
            :loading="loading"
            :disabled="$v.$invalid"
            >Change</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import formatterMixin from "@/mixins/formatterMixin";
import { required, sameAs } from "vuelidate/lib/validators";
import validationMixin from "@/mixins/validationMixin";
import { mapState, mapActions } from "vuex";

export default {
  components: {
  },
  mixins: [formatterMixin, validationMixin],
  props: {
    item: [Object, String],
    show: [Boolean, String],
  },

  validations: {
    form: {
      currentPassword: { required },
      newPassword: { required },
      confirmPassword: { required, passwordMatch: sameAs("newPassword") },
    },
  },
  validationMessages: {
    form: {
      currentPassword: { required: "Required" },
      newPassword: { required: "Required" },
      confirmPassword: {
        required: "Required",
        passwordMatch: "Must match New Password"
      },
    },
  },

  data() {
    return {
      dialog: false,
      loading: false,
      valid: false,

      currentVisible: false,
      newVisible: false,
      confirmVisible: false,

      form: {
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
      },

    };
  },

  computed: {
    ...mapState({
      accountStatus: (state) => state.account.status,
      accountGroupName: (state) => state.account.data.user.userGroupName
    }),
  },
  watch: {
    async dialog(n) {
      if (!n) {
        this.closeDelete();
      }
    },
    show(n, o) {
      if (n && !o) {
        this.dialog = true;
      }
    },
  },

  methods: {
    ...mapActions({
      changePassword: "account/changePassword",
      changeAdminPassword: "account/changeAdminPassword",
      clearStatus: "account/clearStatus",
    }),

    async submit() {
      this.loading = true;
      if(this.accountGroupName === "Super Admin") {
        const payload = {
          oldPassword: this.form.currentPassword,
          newPassword: this.form.newPassword,
          confirmNewPassword: this.form.confirmPassword
        }
        await this.changeAdminPassword(payload);
      } else {
        const payload = {
          password: this.form.newPassword,
          confirmPassword: this.form.confirmPassword
        }
        await this.changePassword(payload);
      }
      this.loading = false;

      if (!this.accountStatus.error) {
        this.closeDelete();
      }
    },

    closeDelete() {
      this.dialog = false;
      this.form.currentPassword = "";
      this.form.newPassword = "";
      this.form.confirmPassword = "";
      this.clearStatus();
      this.$emit("onClosed");
    },
  },
};
</script>